import Request from '../../data/request';

// @ts-ignore
import { Deferred } from 'simply-deferred';
import Moment from 'moment';
import DatetimeUtils from "../../utils/datetime-utils";

export default class ApiMyTime {


    // V3
    static deleteTimeReportV3(timeReportId:ID, viewForUserId:ID) {
        // const _userIdGetParams = (userId:ID) => userId ? '?userId={0}'.f(userId) : ''

        return new Request(this,'POST','time-report/'+timeReportId+'/delete',{
            needMyTimeResponse  : true
        })
    }

    static updateTimeReportV3(timeReportId:ID, reportedMinutes:number, viewForUserId:ID, startMoment?:Moment | null, endMoment?:Moment | null) {

        // return new Request(this,'PUT','time-report/time-report{0}'.f(_userIdGetParams(viewForUserId)), {
        return new Request(this,'POST','time-report/'+timeReportId+'/update', {
            reportedTimeMinutes : reportedMinutes,
            startMoment         : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
            endMoment           : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
            needMyTimeResponse  : true
        })
    }

    static createSkipGuesstimate(taskId:ID, date:Moment, userId:ID) {

        return new Request(this,'POST','time-report/create-for-task', {
            userId              : userId,
            taskId              : taskId,
            date                : date.format("YYYY-MM-DD"),
            skipEstimating      : true,
            needMyTimeResponse  : true
        })
    }

    static addTimeReportV3(taskId:ID, date:Moment, reportedMinutes:number|null, message:string|null, messageRTF:any, viewForUserId:ID, startMoment?:Moment | null, endMoment?:Moment | null) {

        return new Request(this,'POST','time-report/create-for-task', {
            userId              : viewForUserId,
            taskId              : taskId,
            date                : date.format("YYYY-MM-DD"),
            reportedTimeMinutes : reportedMinutes,
            message             : message,
            messageRTF          : messageRTF,
            startMoment         : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
            endMoment           : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
            needMyTimeResponse  : true
        })
    }

    static getDailyDataV3(date:Moment, viewForUserId:ID) {
        return new Request(this, 'POST', 'my-time-v2/daily',{
            date        : date.format("YYYY-MM-DD"),
            userId      : viewForUserId
        });
    }

    static getWeeklyDataV3(companyId:ID, date:any, viewForUserId:ID) {

        const weekRange = DatetimeUtils.getWeekDaterangeByDate(date);

        return new Request(this, 'POST', 'my-time-v2/weekly', {
            companyId:  companyId,
            startDate:  weekRange.start.format("YYYY-MM-DD"),
            endDate:    weekRange.end.format("YYYY-MM-DD"),
            userId:     viewForUserId
        });
    }

    // used only in daily view
    static changeWorkdayV3(date:Moment, viewForUserId:ID, workdayMinutes?:number | boolean,  breakMinutes?: number | boolean) {

        const params: any = {
            date                : date.format("YYYY-MM-DD"),
            userId              : viewForUserId,
            needMyTimeResponse  : true
        }

        if(!!workdayMinutes || workdayMinutes === 0){
            params.workdayMinutes = workdayMinutes;
        }

        if(!!breakMinutes || breakMinutes === 0){
            params.breakMinutes = breakMinutes;
        }

        return new Request(this,'POST','my-time-v2/workday', params)
    }



    // NEW
    // static changeWorkdayV2(minutes:number, date:Moment, viewForUserId:ID) {
    //
    //     const _userIdGetParams = (userId:ID) => userId ? '?userId={0}'.f(userId) : ''
    //
    //     return new Request(this,'PUT','my-time/workday/{0}{1}'.f(date.format("YYYY-MM-DD"), _userIdGetParams(viewForUserId)), {
    //         companyId   : gd.companyId,
    //         workday     : minutes
    //     })
    // }

    // static getDailyReportV2(date:Moment, viewForUserId:ID) {
    //     return new Request(this, 'GET', 'my-time/{0}'.f(date.format("YYYY-MM-DD")),{
    //         userId:     viewForUserId
    //     });
    // }


    // static updateTimeReportV2(timeReportId:ID, reportedMinutes:number, viewForUserId:ID, startMoment?:Moment, endMoment?:Moment) {
    //     const _userIdGetParams = (userId:ID) => userId ? '?userId={0}'.f(userId) : ''
    //
    //     return new Request(this,'PUT','my-time/time-report{0}'.f(_userIdGetParams(viewForUserId)), {
    //         timeReportId    : timeReportId,
    //         reportedMinutes : reportedMinutes,
    //         startMoment     : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
    //         endMoment       : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
    //     })
    // }

    // static addTimeReportV2(taskId:ID, date:string, reportedMinutes:number|null, message:string|null, messageRTF:any, viewForUserId:ID, startMoment?:Moment, endMoment?:Moment) {
    //     const _userIdGetParams = (userId:ID) => userId ? '?userId={0}'.f(userId) : ''
    //
    //     return new Request(this,'POST','my-time/time-report{0}'.f(_userIdGetParams(viewForUserId)), {
    //         taskId          : taskId,
    //         date            : date,
    //         reportedMinutes : reportedMinutes,
    //         message         : message,
    //         messageRTF      : messageRTF,
    //         startMoment     : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
    //         endMoment       : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
    //     })
    // }

    // static getWeeklyReportV2(companyId:ID, date:any, viewForUserId:ID) {
    //     // @ts-ignore
    //     const weekRange = DatetimeUtils.getWeekDaterangeByDate(date);
    //
    //     return new Request(this, 'GET', 'my-time/report', {
    //         companyId:  companyId,
    //         startDate:  weekRange.start.format("YYYY-MM-DD"),
    //         endDate:    weekRange.end.format("YYYY-MM-DD"),
    //         userId:     viewForUserId
    //     });
    // }

    // static deleteTimeReportV2(timeReportId:ID, viewForUserId:ID) {
    //     const _userIdGetParams = (userId:ID) => userId ? '?userId={0}'.f(userId) : ''
    //     return new Request(this,'DELETE','my-time/time-report/{0}{1}'.f(timeReportId, _userIdGetParams(viewForUserId)));
    // }

    // static updateTimeReportUniversal(timeReportId:ID, params:any) {
    //     return new Request(this,'POST','time-report/'+timeReportId+'/update', params);
    // }

    // Used in Analytics (!)
    static customReport(startDate:Moment, endDate:Moment, viewForUserId:ID, taskTypeIds?:ID[]) {
        return new Request(this, 'POST', 'my-time/report', {
            companyId:  gd.companyId,
            startDate:  Moment(startDate).format("YYYY-MM-DD"),
            endDate:    Moment(endDate).format("YYYY-MM-DD"),
            userId:     viewForUserId,
            taskTypeIds : taskTypeIds
        });
    }

    // OLD



    _userIdGetParams = (userId?:ID) => userId ? '?userId={0}'.f(userId) : ''

    // getDailyReport(date:Moment, viewForUserId:ID) {
    //     return new Request(this, 'GET', 'my-time/{0}'.f(date.format("YYYY-MM-DD")),{
    //         userId:     viewForUserId
    //     });
    // }

    // getWeeklyReport(companyId:ID, date:any, viewForUserId:ID) {
    //     // @ts-ignore
    //     const weekRange = DatetimeUtils.getWeekDaterangeByDate(date);
    //
    //     return new Request(this, 'GET', 'my-time/report', {
    //         companyId:  companyId,
    //         startDate:  weekRange.start.format("YYYY-MM-DD"),
    //         endDate:    weekRange.end.format("YYYY-MM-DD"),
    //         userId:     viewForUserId
    //     });
    // }

    // getCustomReport(companyId:ID, startDate:Moment, endDate:Moment, viewForUserId:ID) {
    //     return new Request(this, 'GET', 'my-time/report', {
    //         companyId:  companyId,
    //         startDate:  Moment(startDate).format("YYYY-MM-DD"),
    //         endDate:    Moment(endDate).format("YYYY-MM-DD"),
    //         userId:     viewForUserId
    //     });
    // }

    // getDailyTasksSuggestions(date:Moment, viewForUserId:ID) {
    //     return new Request(this, 'GET', 'my-time/task-suggestions/'+date.format("YYYY-MM-DD"),{
    //         userId:     viewForUserId
    //     });
    // }

    newTaskReport(title:string, companyId:ID, projectId:ID, typeId:ID, statusId:ID, reportedMinutes:number, date:Moment, viewForUserId:ID) {
        const res = new Deferred();

        if (title && projectId && typeId && statusId && reportedMinutes && date) {
            const result = new Request(this, 'POST', 'new-task', {
                title:              title,
                project:            projectId,
                companyId:          companyId,
                type:               typeId,
                user:               viewForUserId ? viewForUserId : gd.session.me.id,
                statusId:           statusId
            });

            result.done((data:any)=>{
                gd.session.recent.projectsNewTask.projectView(projectId);
                const reportResult = this.addTimeReport(
                    data.data.newTask.id,
                    date.format("YYYY-MM-DD"),
                    reportedMinutes,
                    null,
                    null,
                    viewForUserId
                );

                reportResult.done((d:any)=>{
                    res.resolve(d);
                });
            });
        }

        return res;
    }

    addTimeReport(taskId:ID, date:string, reportedMinutes:number|null, message:string|null, messageRTF:any, viewForUserId:ID, startMoment?: Moment | null, endMoment?: Moment | null) {
        return new Request(this,'POST','my-time/time-report{0}'.f(this._userIdGetParams(viewForUserId)), {
            taskId          : taskId,
            date            : date,
            reportedMinutes : reportedMinutes,
            message         : message,
            messageRTF      : messageRTF,
            startMoment     : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
            endMoment       : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
        })
    }

    addTimeReportToMessage(taskMessageId:ID, date:string, reportedMinutes:number, startMoment?: Moment | null, endMoment?: Moment | null) {
        return new Request(this,'POST','time-report/create/task-messages', {
            taskMessageId,
            date,
            reportedMinutes,
            startMoment         : startMoment ? DatetimeUtils.momentToUTCISODatetime(startMoment) : undefined,
            endMoment           : endMoment ? DatetimeUtils.momentToUTCISODatetime(endMoment) : undefined,
        })
    }

    updateTimeReport(timeReportId:ID, reportedMinutes:number, viewForUserId?:ID) {
        return new Request(this,'PUT','my-time/time-report{0}'.f(this._userIdGetParams(viewForUserId)), {
            timeReportId:       timeReportId,
            reportedMinutes:    reportedMinutes
        });
    }

    updateTimeReportDate(timeReportId:ID, reportDate:Moment) {
        return new Request(this,'PUT','my-time/time-report/{0}/update'.f(timeReportId), {
            date:       reportDate.format('YYYY-MM-DD')
        });
    }

    updateTimeReportMessage(timeReportId:ID, message:any, messageRTF:any, viewForUserId?:ID) {
        return new Request(this,'PUT','my-time/time-report/{0}/message{1}'.f(timeReportId, this._userIdGetParams(viewForUserId)), {
            message:    message,
            messageRTF: messageRTF
        });
    }

    deleteTimeReport(timeReportId:ID, viewForUserId:ID) {
        return new Request(this,'DELETE','my-time/time-report/{0}{1}'.f(timeReportId, this._userIdGetParams(viewForUserId)));
    }

    // skipTaskEstimate(taskId:ID, date:string, viewForUserId:ID) {
    //     return new Request(this,'POST','my-time/skip-estimate{0}'.f(this._userIdGetParams(viewForUserId)), {
    //         taskId: taskId,
    //         date:   date
    //     });
    // }

    // changeWorkday(companyId:ID, minutes:number, date:string, viewForUserId:ID) {
    //
    //     const _userIdGetParams = (userId:ID) => userId ? '?userId={0}'.f(userId) : ''
    //
    //     return new Request(this,'PUT','my-time/workday/{0}{1}'.f(date, _userIdGetParams(viewForUserId)), {
    //         companyId:      companyId,
    //         workday:    minutes
    //     });
    // }


    getTimeReport(timeReportId:ID) {
        return new Request(this,'GET','time-report/{0}'.f(timeReportId));
    }

}
